<!-- Badge officiel « Disponible sur Google Play » (Google, version française) :
     ne jamais le redessiner ni le recolorer. 40 px de haut, comme le badge Apple. -->
<template>
  <img src="/badges/disponible-sur-google-play.png" alt="Disponible sur Google Play" class="h-10 w-auto" />
</template>
